import { Link } from "react-router-dom";
import { my_routes } from "../../../feature-module/router/all_routes";

import { useSocket } from "../context/SocketContext";
import { toast } from "sonner";
import { useEffect, useState } from "react";
import { get_messages_for_user } from "../../../api/messages";
export type NotificationHeaderProps = {
  notificationVisible: boolean;
  toggleNotification: () => void;
};

const NotificationHeader = ({
  notificationVisible,
  toggleNotification,
}: NotificationHeaderProps) => {
  const routes = my_routes;

  // Context Socket
  const { socket, ready } = useSocket();

  const [myMessages, setMyMessages] = useState<any[]>([]);
  const [filter, setFilter] = useState<string>("today");
  const [filteredMessages, setFilteredMessages] = useState<any[]>([]);

  useEffect(() => {
    if (!socket) {
      // console.log("Pas de socket enregistré !");
      return;
    }

    // ✅ connexion réussie
    socket.on("connect", () => {
      // console.log("🟢 Socket connecté avec succès");
    });

    // ❌ erreur de connexion
    socket.on("connect_error", (err: any) => {
      // console.error("🔴 Erreur socket :", err.message);
    });

    return () => {
      socket.off("connect");
      socket.off("connect_error");
    };
  }, [socket]);

  useEffect(() => {
    if (!socket) return;

    socket.on("new_message", (data: any) => {
      // console.log("Nouveau message reçu :", data);
      fetch_all_my_message();
      toast.success("📩 Message reçu !");
    });

    return () => {
      socket.off("new_message");
    };
  }, [socket]);

  useEffect(() => {
    if (!notificationVisible) return;
    fetch_all_my_message();
  }, [notificationVisible]);

  const fetch_all_my_message = async () => {
    try {
      const response = await get_messages_for_user();
      const data = Array.isArray(response?.data) ? response.data : [];
      const sorted = data.sort(
        (a: any, b: any) =>
          new Date(b?.createdAt || 0).getTime() -
          new Date(a?.createdAt || 0).getTime(),
      );
      // console.log("Messages triés :", sorted);
      setMyMessages(sorted);
    } catch (error: any) {
      // console.log("erreur de chargement des messages : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const typeClass = (t?: string) =>
    t === "Urgent"
      ? "bg-danger"
      : t === "Avertissement"
        ? "bg-warning"
        : "bg-info";

  const formatDate = (v?: string) => {
    if (!v) return "";
    const d = new Date(v);
    const today = new Date();
    const isToday = d.toDateString() === today.toDateString();
    const time = d.toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
    });
    return isToday ? time : `${d.toLocaleDateString("fr-FR")} ${time}`;
  };

  const now = new Date();
  const day = now.getDay();
  const mondayOffset = (day + 6) % 7;
  const startOfWeek = new Date(now);
  startOfWeek.setHours(0, 0, 0, 0);
  startOfWeek.setDate(now.getDate() - mondayOffset);
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 7);
  const startOfLastWeek = new Date(startOfWeek);
  startOfLastWeek.setDate(startOfWeek.getDate() - 7);
  const endOfLastWeek = new Date(startOfWeek);
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);

  useEffect(() => {
    const messages = myMessages.filter((m: any) => {
      const d = m?.createdAt ? new Date(m.createdAt) : null;
      if (!d) return false;
      if (filter === "today") return d.toDateString() === now.toDateString();
      if (filter === "thisWeek") return d >= startOfWeek && d < endOfWeek;
      if (filter === "lastWeek")
        return d >= startOfLastWeek && d < endOfLastWeek;
      if (filter === "thisMonth") return d >= startOfMonth && d < endOfMonth;
      return true;
    });
    setFilteredMessages(messages);
  }, [filter, myMessages]);
  const filterLabel =
    filter === "today"
      ? "Aujourd'hui"
      : filter === "thisWeek"
        ? "Cette Semaine"
        : filter === "lastWeek"
          ? "Semaine Passée"
          : filter === "thisMonth"
            ? "Ce Mois"
            : "Tous";

  return (
    <>
      {/* NOTIFICATION */}
      <div
        className={`pe-1 ${
          notificationVisible ? "notification-item-show" : ""
        } `}
        id="notification_item"
      >
        <div className="dropdown-menu dropdown-menu-end notification-dropdown notif-responsive p-4">
          <div className="d-flex  align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
            <h4 className="notification-title">
              Notifications ({filteredMessages.length})
            </h4>
            <div className="d-flex align-items-center">
              {/* <Link to="#" className="text-primary fs-15 me-3 lh-1">
                Marquer Tout comme Lus
              </Link> */}
              <div className="dropdown">
                <Link
                  to="#"
                  className="bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-calendar-due me-1" />
                  {filterLabel}
                </Link>
                <ul className="dropdown-menu mt-2 p-3">
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={() => setFilter("thisWeek")}
                    >
                      Cette Semaine
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={() => setFilter("lastWeek")}
                    >
                      Semaine Passée
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={() => setFilter("today")}
                    >
                      Aujourd'hui
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={() => setFilter("thisMonth")}
                    >
                      Ce Mois
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={() => setFilter("all")}
                    >
                      Tous
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="noti-content">
            <div className="d-flex flex-column w-100">
              {filteredMessages.length > 0 ? (
                filteredMessages.map((msg: any) => {
                  const senderName =
                    `${msg?.UserProfil?.firstname || ""} ${msg?.UserProfil?.lastname || ""}`.trim() ||
                    "Utilisateur";
                  const initial =
                    (
                      (msg?.UserProfil?.firstname?.charAt(0) || "") +
                      (msg?.UserProfil?.lastname?.charAt(0) || "")
                    ).toUpperCase() || "U";

                  return (
                    <div key={msg.id} className="border-bottom mb-3 pb-3">
                      <Link to={routes.messagePage}>
                        <div className="d-flex w-100 notif-item-row">
                          <span className="avatar avatar-lg notif-avatar me-2 flex-shrink-0 bg-primary text-white d-flex align-items-center justify-content-center rounded-circle">
                            {initial}
                          </span>
                          <div className="flex-grow-1">
                            <p className="mb-1 d-flex align-items-center justify-content-between gap-2 notif-title-row">
                              <span className="text-dark fw-semibold">
                                {senderName}
                              </span>
                              <span
                                className={`badge badge-sm ${typeClass(msg?.message_type)}`}
                              >
                                {msg?.message_type}
                              </span>
                            </p>
                            <p className="mb-1 message-preview">
                              {msg?.message && msg.message.length > 50
                                ? `${msg.message.slice(0, 50)}...`
                                : msg?.message}
                            </p>
                            <span>{formatDate(msg?.createdAt)}</span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })
              ) : (
                <div className="text-center text-muted">
                  Aucune notification
                </div>
              )}
            </div>
          </div>
          <div className="d-flex p-0">
            <Link
              to="#"
              onClick={toggleNotification}
              className="btn btn-light w-100 me-2"
            >
              Fermer
            </Link>
            <Link
              to={routes.messagePage}
              onClick={toggleNotification}
              className="btn btn-primary w-100"
            >
              Voir Tous
            </Link>
          </div>
        </div>
      </div>
      {/* NOTIFICATION END */}
      <style>{`
        .notification-dropdown.notif-responsive {
          width: 380px;
          max-width: 58vw;
          max-height: 70vh;
          overflow: auto;
          padding: 0.75rem !important;
        }
        .message-preview {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .notif-title-row { gap: 8px; }
        @media (max-width: 576px) {
          .notification-dropdown.notif-responsive {
            width: 300px;
            max-width: 70vw;
            right: 8px;
            left: auto;
          }
          .notif-item-row { flex-direction: column; align-items: flex-start; gap: 6px; }
          .notif-avatar { width: 28px; height: 28px; font-size: 12px; }
          .notification-title { font-size: 15px; }
        }
      `}</style>
    </>
  );
};

export default NotificationHeader;
